import React from "react";

// NEWZER Marken-Assets – verbindlich gelieferte Dateien, unverändert verwenden
// (nicht als Text nachbauen, keine Farben/Effekte hinzufügen).
const V = "?v=2"; // Asset-Version / Cache-Busting
const WORDMARK = {
  black: `/brand/newzer-wordmark-black.png${V}`, // helle Hintergründe
  white: `/brand/newzer-wordmark-white.png${V}`, // dunkle Hintergründe & Bilder
};
const MARK = {
  black: `/brand/newzer-mark-black.png${V}`,
  white: `/brand/newzer-mark-white.png${V}`,
};
const WORDMARK_RATIO = 1536 / 371; // Seitenverhältnis fixieren, kein Layout-Shift
const ALT = "newzer – Informationen früh erkennen";

// Nur Bildmarke – für kompakte/mobile Darstellungen, Icons.
export function LogoMark({ size = 40, variant = "color", className = "" }) {
  const src = variant === "white" ? MARK.white : MARK.black;
  return (
    <img src={src} alt={ALT} width={size} height={size} data-testid="newzer-logomark"
      className={className} style={{ objectFit: "contain", display: "block" }} />
  );
}

// Rückwärtskompatibel (Wortmarke steckt in der SVG/PNG-Datei selbst)
export function Wordmark() { return null; }

export default function Logo({ size = 34, variant = "color", withWordmark = true, textSize, className = "" }) {
  if (!withWordmark) return <LogoMark size={size} variant={variant} className={className} />;
  const src = variant === "white" ? WORDMARK.white : WORDMARK.black;
  const width = Math.round(size * WORDMARK_RATIO);
  return (
    <img src={src} alt={ALT} className={className} data-testid="newzer-logo"
      width={width} height={size}
      style={{ height: size, width: `${width}px`, objectFit: "contain", display: "block" }} />
  );
}
